module.exports = __webpack_public_path__ + "static/media/nwcc.d1b6bfd8.png";